export const adminRoles = ['SuperAdmin', 'Admin']
export const userRoles = ['Manager', 'User']
